<div class="no-results-message">
    <div class="main" trans>No recent entries.</div>
    <div class="secondary" trans>You have not uploaded any files or folders yet.</div>
    <mat-icon svgIcon="recent-custom" class="icon"></mat-icon>
</div>